import { render, staticRenderFns } from "./main-hospital-panel.vue?vue&type=template&id=20665474&scoped=true"
import script from "./main-hospital-panel.vue?vue&type=script&lang=js"
export * from "./main-hospital-panel.vue?vue&type=script&lang=js"
import style0 from "./main-hospital-panel.vue?vue&type=style&index=0&id=20665474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20665474",
  null
  
)

export default component.exports